import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { Credit, CreditType } from '@/models/credit';
import { Money } from '@/models/money';

const baseUrl = urlBuilder('order', 'credit');

type PostCreditBody = {
    customerId: string;
    amount: Money;
    type: CreditType;
    comment: string;
    liftOperatorId?: string;
};

export const creditApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['CREDIT'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCredit: builder.query<Credit, { customerId: string }>({
                query: ({ customerId }) => `${baseUrl}?userId=${customerId}`,

                providesTags: ['CREDIT'],
            }),

            postCredit: builder.mutation<Credit, PostCreditBody>({
                query: (postBody) => ({
                    url: baseUrl,
                    method: 'POST',
                    body: postBody,
                }),

                invalidatesTags: ['CREDIT'],
            }),
        }),
    });

export const { useGetCreditQuery, usePostCreditMutation } = creditApi;
